/* SARATTI LUX — transparent header over the hero (desktop >=1280px only)
   + white logo swap while clear. */
(function () {
  var CLEAR_LOGO = 'https://saratti.com/cdn/shop/files/Transparent-Long-_-Saratti-Logo_19e4fa83-5a3b-416f-956d-51f6694a264f.png';
  var mq = window.matchMedia('(min-width: 1280px)');
  function init() {
    if (!document.querySelector('.lux-hero')) return;
    var logo = document.querySelector('.cc-header .header__logo img');
    var orig = null, origSrcset = null;
    if (logo) { orig = logo.getAttribute('src'); origSrcset = logo.getAttribute('srcset'); }
    var set = function () {
      var clear = mq.matches && window.scrollY < 60;
      document.documentElement.classList.toggle('lux-header-clear', clear);
      if (logo) {
        if (clear) {
          if (logo.getAttribute('src') !== CLEAR_LOGO) {
            logo.setAttribute('src', CLEAR_LOGO);
            logo.removeAttribute('srcset');
          }
        } else if (orig && logo.getAttribute('src') !== orig) {
          logo.setAttribute('src', orig);
          if (origSrcset) logo.setAttribute('srcset', origSrcset);
        }
      }
    };
    set();
    window.addEventListener('scroll', set, { passive: true });
    window.addEventListener('resize', set, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', set);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
